<template>
  <div class="c-proposal-improvement">
    <div class="c-proposal-improvement__inner">
      <div class="c-proposal-improvement__image">
        <div class="c-image--radius">
          <img src="@/assets/img/img-chara-task.svg" alt="" width="76" />
        </div>
      </div>
      <div class="c-proposal-improvement__content">
        <h3 class="c-proposal-improvement__title">
          <template v-if="isChangeTd">
            タイトルの変更でクリック率を改善しましょう！
          </template>
          <template v-else-if="isRewrite">
            コンテンツのリライト（加筆・修正）で順位を改善しましょう！
          </template>
          <template v-else-if="isSeoCheck">
            <ProposalContentSeoIssuesTitle :proposal="proposal" />
          </template>
        </h3>
        <ul class="c-proposal-target">
          <li v-if="!isSeoCheck" class="c-proposal-target__item">
            <div class="c-proposal-target__title">
              対象キーワード
            </div>
            <div class="c-proposal-target__content">
              {{ proposal.keyword }}
            </div>
          </li>
          <li class="c-proposal-target__item">
            <div class="c-proposal-target__title">対象URL</div>
            <div class="c-proposal-target__content">
              {{ proposal.url | removeDomain(project.siteUrl) }}
            </div>
          </li>
        </ul>
        <template v-if="isChangeTd">
          <p>
            順位が高く、表示回数が多いわりに、クリック率が少ないキーワードがあります。コンテンツの<span
              class="c-text--main"
              >タイトル・ディスクリプション</span
            >を変更してみましょう。
          </p>
        </template>
        <template v-else-if="isRewrite">
          <p>
            検索ボリュームが多く、惜しい順位（6位～50位）のキーワードが存在します。コンテンツの「網羅性」「独自性」「専門性」を見直してみましょう。
          </p>
        </template>
        <template v-else-if="isSeoCheck">
          <ProposalContentSeoIssues :proposal="proposal" />
        </template>
        <Button variant="main" fsize="f12" class="l-w-180" @click.stop="focus">
          提案箇所を確認してみる
        </Button>
      </div>
    </div>
    <ProposalTask
      :project="project"
      :proposal="proposal"
      @accept="accept"
      @reject="reject"
    />
  </div>
</template>

<script>
import Button from '@/components/Button';
import ProposalContentSeoIssues from '@/components/proposal/ProposalContentSeoIssues';
import ProposalContentSeoIssuesTitle from '@/components/proposal/ProposalContentSeoIssuesTitle';
import ProposalTask from '@/components/proposal/ProposalTask';
export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    proposal: {
      type: Object,
      required: false
    }
  },
  components: {
    Button,
    ProposalContentSeoIssues,
    ProposalContentSeoIssuesTitle,
    ProposalTask
  },
  computed: {
    isChangeTd() {
      return this.proposal.type === 'changeTd';
    },
    isRewrite() {
      return this.proposal.type === 'rewrite';
    },
    isSeoCheck() {
      return this.proposal.type === 'seoCheckUp';
    }
  },
  methods: {
    accept() {
      this.$emit('accept');
    },
    focus() {
      this.$emit('focus');
    },
    reject() {
      this.$emit('reject');
    }
  }
};
</script>
